import { Router } from '@vaadin/router';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";

class KbTopicBreadcrumbs extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
        this.crumbArray = [];
        if(this.node){
            this.crumbArray = [];
            this._buildCrumbArray(this.node)
            this.crumbArray.reverse();
            this.myRender();
        }
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    _buildCrumbArray(node){
        if(node.title){
            this.crumbArray.push(node)
        }
        if(node.parent){
            this._buildCrumbArray(node.parent)
        }
    }


    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.node){
            this.crumbArray = [];
            this._buildCrumbArray(this.node)
            this.crumbArray.reverse();
            this.myRender();
        }
    }
    
    myRender(){
        render(this.tocItemTemplate(), this.shadowRoot);
        }
       
    tocItemTemplate(){
       return html`
            <style>
                ul{
                    list-style:none;
                    display:inline-block;
                    padding-left:0px;
                }
                li{
                    display:inline;
                    margin-right: 0.25rem;
                }
                li span.title{
                    cursor: pointer;
                    text-decoration: underline;
                    color: var(--kb-on-surface-link-color);
                }

                li:last-child span.title{
                    text-decoration: none;
                    color: var(--kb-on-surface-color-muted);
                    cursor: default;
                }
                li:last-child span.foo{
                    display:none;
                }


            </style>
            <span>
            <ul>
                ${this.crumbArray.map((item) => 
                    html`
                        <li>
                        <span class='title' @click='${this._itemClicked.bind(this, item)}'>${item.title}</span>
                        <span class='foo'>&nbsp;></span> 
                        </li>
                `)}
            </ul>
            </span>
           `;
        }

    _itemClicked(itm,e){
        if(this.node.href){
            if(this.node.href!=itm.href){
                this.dispatchEvent(new CustomEvent('tocItemClicked', {
                    bubbles: true,
                    composed: true,
                    detail: itm
                    }));
                }
            }
        }
}

customElements.define('kb-topic-breadcrumbs', KbTopicBreadcrumbs)
